import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(data: Array<any>, searchTxt: string, kerArgs:string ): Array<any> {

    return data?.filter(getData);
        function getData(value, index){

          for(let key of kerArgs){

            if(value[key]?.toUpperCase().indexOf(searchTxt?.trim().toUpperCase()) > -1 ) {
                return data[index];
              }
            }

        };
        


  };

  }